import { Provider } from "@malloc-protocol/anchor";
import { AnchorWallet } from "@solana/wallet-adapter-react";
import { Connection } from "@solana/web3.js";
import { getConstants } from "../config/constants";

export const getProvider = (wallet: AnchorWallet): Provider => {
  return new Provider(new Connection(getConstants().solana.RPC), wallet, {});
};
